(() => {
  const reducedMotion = () => document.body.dataset.motion === 'false' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let menu;
  function initializeMenu() {
    const dialog = document.querySelector('#MoodMenu');
    if (menu?.dialog === dialog) return;
    menu?.dispose();
    menu = null;
    if (!dialog) return;
    const events = new AbortController();
    let returnFocus, closeTimer;
    const setExpanded = value => document.querySelectorAll('[data-menu-open]').forEach(trigger => trigger.setAttribute('aria-expanded', String(value)));
    const position = () => {
      const bottom = document.querySelector('[data-header]')?.getBoundingClientRect().bottom || 78;
      dialog.style.setProperty('--menu-top', `${Math.max(0, Math.min(bottom, innerHeight - 240))}px`);
    };
    function open(trigger) {
      clearTimeout(closeTimer);
      dialog.removeAttribute('data-closing');
      position();
      if (dialog.open) return;
      returnFocus = trigger || document.activeElement;
      dialog.showModal();
      document.body.classList.add('menu-is-open');
      setExpanded(true);
    }
    function close() {
      if (!dialog.open || dialog.hasAttribute('data-closing')) return;
      if (reducedMotion()) { dialog.close(); return; }
      dialog.setAttribute('data-closing', '');
      closeTimer = setTimeout(() => dialog.close(), 160);
    }
    const options = { signal: events.signal };
    dialog.querySelector('[data-menu-close]').addEventListener('click', close, options);
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); }, options);
    dialog.addEventListener('close', () => {
      clearTimeout(closeTimer);
      dialog.removeAttribute('data-closing');
      document.body.classList.remove('menu-is-open');
      setExpanded(false);
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    }, options);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }, options);
    const choices = dialog.querySelectorAll('[data-mood]');
    const scenes = dialog.querySelectorAll('[data-mood-scene]');
    function preview(id) {
      choices.forEach(item => item.classList.toggle('is-current', item.dataset.mood === id));
      scenes.forEach(scene => scene.classList.toggle('is-current', scene.dataset.moodScene === id));
    }
    choices.forEach(choice => {
      choice.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') preview(choice.dataset.mood); }, options);
      choice.addEventListener('focusin', () => preview(choice.dataset.mood), options);
    });
    window.addEventListener('resize', position, options);
    menu = { dialog, open, close, preview, dispose() { clearTimeout(closeTimer); if (dialog.open) dialog.close(); events.abort(); document.body.classList.remove('menu-is-open'); setExpanded(false); } };
    if (new URLSearchParams(location.search).get('menu') === 'open') open(document.querySelector('[data-menu-open]'));
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-menu-open]');
    if (trigger) { initializeMenu(); menu?.open(trigger); }
  });
  initializeMenu();
  document.addEventListener('shopify:section:load', initializeMenu);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(menu?.dialog)) { menu.dispose(); menu = null; }
  });
  document.addEventListener('shopify:section:select', event => {
    initializeMenu();
    if (event.target.contains(menu?.dialog)) menu.open();
  });
  document.addEventListener('shopify:block:select', event => {
    initializeMenu();
    const choice = event.target.closest('[data-mood]');
    if (!choice || !menu) return;
    menu.open(); menu.preview(choice.dataset.mood);
    choice.scrollIntoView({ block: 'nearest', behavior: 'instant' });
  });
})();
